import { createFilterContext } from '../../common/filter/createFilterContext';

type CalendarFilterState = {
  selectedOrderPageIds: string[] | null;
  showEmployees: boolean;
  showShifts: boolean;
  showNotes: boolean;
  showUnavailabilities: boolean;
  showOnlyMine: boolean;
};

const { Provider: CalendarFilterProvider, useBaseFilter } = createFilterContext<CalendarFilterState>({
  storageKey: 'webook-calendar-filter',
  defaults: {
    selectedOrderPageIds: null,
    showEmployees: true,
    showShifts: true,
    showNotes: true,
    showUnavailabilities: true,
    showOnlyMine: false,
  },
  isActive: (s) =>
    s.selectedOrderPageIds !== null ||
    !s.showEmployees ||
    !s.showShifts ||
    !s.showNotes ||
    !s.showUnavailabilities ||
    s.showOnlyMine,
});

export { CalendarFilterProvider };

export const useCalendarFilter = () => {
  const { state, setState, isActive, reset } = useBaseFilter();
  return {
    selectedOrderPageIds: state.selectedOrderPageIds,
    setSelectedOrderPageIds: (v: string[] | null) => setState({ selectedOrderPageIds: v }),
    showEmployees: state.showEmployees,
    setShowEmployees: (v: boolean) => setState({ showEmployees: v }),
    showShifts: state.showShifts,
    setShowShifts: (v: boolean) => setState({ showShifts: v }),
    showNotes: state.showNotes,
    setShowNotes: (v: boolean) => setState({ showNotes: v }),
    showUnavailabilities: state.showUnavailabilities,
    setShowUnavailabilities: (v: boolean) => setState({ showUnavailabilities: v }),
    showOnlyMine: state.showOnlyMine,
    setShowOnlyMine: (v: boolean) => setState({ showOnlyMine: v }),
    isFilterActive: isActive,
    resetFilter: reset,
  };
};
